import { useAuth, useUser } from '@myosh/myosh-login';
import { AboutInfoModal } from '@myosh/odin-components';
import { useGetEnvironmentQuery } from '../../api/generated/v4-api';

interface AboutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AboutModal = ({ isOpen, onClose }: AboutModalProps) => {
  const { data: schemaInfo } = useGetEnvironmentQuery();
  const { logout } = useAuth();

  const { state: userState } = useUser();
  const isControllingSuperuser = Boolean(userState?.user?.superuser === 'true' && userState?.user?.controlledUsername);

  const handleLogOut = () => {
    logout();
    localStorage.clear();
  };

  return (
    <AboutInfoModal
      data-cy="about-info-modal"
      shouldCheckZIndex
      isAboutInfoOpen={isOpen}
      showLogoutButton={true}
      onClose={onClose}
      onLogout={handleLogOut}
      version={process.env.REACT_APP_VERSION}
      schemaTimeZone={schemaInfo?.['time-zone']}
      showUserTimeZone
      currentSchema={{ text: schemaInfo?.schema ?? 'n/a' }}
      controllingSuperuser={isControllingSuperuser ? userState?.user?.preferred_username : undefined}
      openSourceNotices="React Flow © xyflow – MIT"
    />
  );
};

export default AboutModal;
